// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CloseButton_button__YWeOt {
  color: white;
  width: 6rem;
  height: 3rem;
  border-radius: 4px;
  background-color: gray;
}
.CloseButton_button__YWeOt:hover {
  background-color: darkgray;
}
.CloseButton_button__YWeOt:active {
  background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/components/PortalModal/CloseButton.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,sBAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;AAEE;EACE,2BAAA;AAAJ","sourcesContent":[".button {\n  color: white;\n  width: 6rem;\n  height: 3rem;\n  border-radius: 4px;\n  background-color: gray;\n}\n.button:hover {\n  background-color: darkgray;\n}\n.button:active {\n  background-color: lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `CloseButton_button__YWeOt`
};
export default ___CSS_LOADER_EXPORT___;
